import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {File} from "../../models/file";
import {InternalFileService} from "../service/internalFile.service";

@Injectable()
export class InternalFileResolve implements Resolve<File> {
    constructor(private fileService: InternalFileService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<File> {
        return this.fileService.getById(route.params.id);
    }
}
